import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { Collapse, Icon, Row, Input, Typography, Form, Modal } from 'antd';
import { dadosGeraisState, ordemCompraIdState, reloadDadosGeraisState, reloadState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { DocuSignAssinantes, atualizarDocuSignOc, getAssinantes, salvarDocuSignId } from '@app/api/DocuSign';
import { isValidGuid } from '@app/helpers/geradorGuid';
import { isObjEmpty } from '@app/helpers/objHelper';
import { Button, Col, MasterDetailForm, Table } from '@digital/ui';


const { Panel } = Collapse;
const { Search } = Input;
const { Title } = Typography;

interface Props {
    parteDoFluxo?: boolean
}

const WidgetDocuSignContrato = ({ parteDoFluxo = false }: Props) => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const dadosGerais = useRecoilValue(dadosGeraisState);
    const [reload, setReload] = useRecoilState(reloadState);
    const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState);

    const [envelopeId, setEnvelopeId] = useState<string>("");
    const [assinantes, setAssinantes] = useState<DocuSignAssinantes>();
    const [historicoEnvelopes, setHistoricosEnvelopes] = useState<any[]>();
    const [disableEnvelopeId, setDisableEnvelopeId] = useState(false)

    useEffect(() => {
        if (dadosGerais) {
            if (dadosGerais.docuSignIdCT) {
                if (isValidGuid(dadosGerais.docuSignIdCT)) {
                    setDisableEnvelopeId(true)
                    setEnvelopeId(dadosGerais.docuSignIdCT)
                    consultaAssinantes(dadosGerais.docuSignIdCT);
                }
            }
        }


    }, [dadosGerais, reload])

    const onReload = () => {
        setReload(!reload);
    };

    const onClickAlterarId = () => {
        setDisableEnvelopeId(false);
        setEnvelopeId("");
    }

    const consultaAssinantes = (envelopeId: string) => {
        getAssinantes(envelopeId, ordemCompraId).then((data: any) => {
            if (data && data.recipients && data.recipients.signers) {
                setAssinantes(data.recipients.signers);
            }
            if (data && data.historico) {
                setHistoricosEnvelopes(data.historicoContrato);
            }
            if (data && data.reload) {
                onReload();
            }
        })
    }

    const onSearchEnvelopeId = () => {
        consultaAssinantes(envelopeId);
    }

    const onSalvarEnvelopeId = () => {

        Modal.confirm({
            title: 'Envelope ID',
            content: `Confirma que o número do Envelope ID está correto?`,
            cancelText: 'Não',
            onCancel: () => { },
            okText: 'Sim',
            onOk: () => {
                var values = {
                    envelopeIdCT: envelopeId
                }
               
                salvarDocuSignId(ordemCompraId, values).then((data: any) => {
                    if (data && data.valid && values.envelopeIdCT != "") {
                        setDisableEnvelopeId(true);
                        consultaAssinantes(values.envelopeIdCT);
                        onReload();
                        setReloadDadosGerais(!reloadDadosGerais);
                    }
                });
            },
        });
    }

    const onAtualizarDocuSign = () => {
        atualizarDocuSignOc(ordemCompraId).then((data: any) => {
            onReload();
        })
    }

    const columnsAssinante = [
        {
            title: "Nome",
            dataIndex: "name",
            width: "40%",
        },
        {
            title: "Email",
            dataIndex: "email",
            width: "20%",
        },
        {
            title: "Assinou",
            dataIndex: "status",
            width: "20%",
            render: (record: any) => {
                return record && record.includes('completed') ? 'Sim' : 'Não';
            }
        },
        {
            title: "Data Assinatura",
            dataIndex: "signedDateTime",
            width: "20%",
            render: (record: any) => {
                return moment(record).format("DD/MM/YYYY HH:mm");
            }
        }
    ];

    const columnsHistorico = [
        {
            title: "Envelope ID",
            dataIndex: "envelopeId",
        },
        {
            title: "Status",
            dataIndex: "status",
        }
    ]

    return (
        <>
            <Collapse
                bordered={false}
                defaultActiveKey="IntegracaoDocuSignCT"
                expandIcon={() => <Icon type="arrows-right_4" />}
            >
                <Panel
                    key="IntegracaoDocuSignCT"
                    header="Integração DocuSign – Assinatura Contrato "
                    showArrow={!parteDoFluxo}
                >
                    <Title level={4}>Envelope Id:</Title>

                    <MasterDetailForm
                        actions={[
                            <>
                                {true && (
                                    <Button type='primary' title='Alterar ID' onClick={onClickAlterarId} />
                                )}
                            </>
                        ]}
                    >

                        <Row>
                            <Form.Item validateStatus={isObjEmpty(envelopeId) ? 'error' : ''} help={isObjEmpty(envelopeId) ? "Envelope Id é obrigatário." : ""} >
                                <Search
                                    style={{ margin: '5px', width: '25%', textAlign: 'justify' }}
                                    placeholder={'Envelope Id'} name={''}
                                    value={envelopeId}
                                    onChange={(e) => {
                                        setEnvelopeId(e.target.value);
                                    }}
                                    onSearch={(e) => {
                                        onSearchEnvelopeId();
                                    }}
                                    disabled={disableEnvelopeId}
                                />
                                <Button type="link" style={{ margin: '5px' }} onClick={onSalvarEnvelopeId}>Salvar</Button>
                                <Button type="link" style={{ margin: '5px' }} onClick={onAtualizarDocuSign}>Consultar</Button>
                            </Form.Item>
                        </Row>
                        <Row>

                            <Table
                                style={{ marginTop: '5px' }}
                                dataSource={assinantes}
                                columns={columnsAssinante}
                                pagination={false}
                                rowKey="id"
                            />
                            <hr />
                        </Row>

                        <Title level={4}>Histórico de Envelopes</Title>
                        <Row>
                            <Col span={6}>
                                <Table
                                    style={{ marginTop: '5px' }}
                                    dataSource={historicoEnvelopes}
                                    columns={columnsHistorico}
                                    pagination={false}
                                    rowKey="id"
                                />
                            </Col>
                        </Row>
                    </MasterDetailForm>
                </Panel>
            </Collapse >
        </>
    )
}

export default WidgetDocuSignContrato